import { buildLocalizedFallback } from './aiChatLanguage';

/** Client-side replies when /api/ai/chat is unavailable */
export const getAiChatFallbackReply = (text = '') => buildLocalizedFallback(text);
